import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '@shared/shared.module';
import { InvitationsService } from '@services/invitations/invitations.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    BrowserAnimationsModule,
    SharedModule
  ],
  schemas: [
		CUSTOM_ELEMENTS_SCHEMA // Tells Angular we will have custom tags in our templates
	],
  providers: [
    InvitationsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
